import { Link, useLocation } from "react-router-dom";
import newLogo from "../../assets/redesign-images/logo.svg";
import { FaArrowRight } from "react-icons/fa6";
import { MdMenu } from "react-icons/md";
import { useState, useEffect } from "react";
import { RxCaretRight } from "react-icons/rx";
import classNames from "classnames";

const Navbar = () => {
  const [height, setHeight] = useState("80px");
  const isLoggedIn = localStorage.getItem("token");
  const location = useLocation();
  const pathname = location.pathname;
  const logoLink = isLoggedIn ? "/overview" : "/";
  const mobileNavHandler = () => {
    setHeight((prev) => (prev === "80px" ? "100vh" : "80px"));
  };

  useEffect(() => {
    if (height === "100vh") {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [height]);

  const routes = [
    { name: "Home", href: "/" },
    {
      name: "Product",
      href: "/products",
    },
    {
      name: "About",
      href: "/about",
    },
    {
      name: "Contact",
      href: "/contact",
    },
  ];

  const Content = (
    <>
      <div
        className={classNames("flex items-center justify-between w-full", {
          "py-8": height === "100vh",
          "h-full": height === "80px",
        })}>
        <div className='flex items-center gap-10'>
          <Link to={logoLink}>
            <img
              src={newLogo}
              alt='app_logo'
              title='VendStash'
              className='w-[130px] lg:w-[140px]'
            />
          </Link>
          <div className='lg:flex items-center gap-10 font-medium hidden'>
            {routes.map((route) => {
              return (
                <Link to={route.href} key={route.name}>
                  {route.name}
                </Link>
              );
            })}
          </div>
        </div>
        {!isLoggedIn && pathname == "/" ? (
          <div className='hidden lg:flex items-center gap-10'>
            <Link
              to={"/signin"}
              onClick={() => setHeight("80px")}
              className='bg-transparent w-full justify-center flex items-center gap-2 px-2 py-1 text-[#030712] whitespace-nowrap text-sm'>
              Log In <FaArrowRight size={18} />
            </Link>
            <Link
              to={"/signup"}
              className='bg-[#0A7BCE] justify-center flex items-center gap-2 px-3 py-2 text-[#F9FAFB] rounded-lg w-full whitespace-nowrap text-sm'>
              Sign Up <FaArrowRight size={18} />
            </Link>
          </div>
        ) : (
          <div className='hidden lg:flex items-center gap-10'>
            {" "}
            <Link
              to={"/overview"}
              onClick={() => setHeight("80px")}
              className='bg-transparent w-full justify-center items-center gap-2 px-2 py-1 text-[#0A7BCE] whitespace-nowrap text-sm flex'>
              Dashboard <FaArrowRight size={18} />
            </Link>
          </div>
        )}
        <div
          className='lg:hidden border border-[#E5E7EB] py-[0.25rem] px-[0.35rem] rounded bg-[#FFFFFF] mobileNavBtn'
          onClick={mobileNavHandler}>
          <MdMenu size={20} color='#1D2939' />
        </div>
      </div>
      <div className='flex flex-col mt-8 gap-8'>
        {routes.map((route) => {
          return (
            <Link
              to={route.href}
              key={route.name}
              className='flex items-center justify-between'
              onClick={() => setHeight("80px")}>
              <p className='text-[#1D2939] font-semibold text-lg'>
                {route.name}
              </p>
              <RxCaretRight size={20} />
            </Link>
          );
        })}
      </div>

      {isLoggedIn ? (
        <div className='lg:hidden absolute w-full left-0 bottom-[90px] flex flex-col gap-4 p-8'>
          {" "}
          <Link
            to={"/overview"}
            onClick={() => setHeight("80px")}
            className='bg-transparent w-full justify-center items-center gap-2 px-2 py-1 text-[#0A7BCE] whitespace-nowrap text-sm flex'>
            Dashboard <FaArrowRight size={18} />
          </Link>
        </div>
      ) : (
        <div className='absolute w-full left-0 bottom-[90px] flex flex-col gap-4 p-8'>
          <Link
            to={"/signin"}
            onClick={() => setHeight("80px")}
            className='bg-transparent w-full h-[45px] justify-center flex items-center gap-2 px-2 py-1 text-[#030712]'>
            Log In <FaArrowRight size={18} />
          </Link>
          <Link
            to={"/signup"}
            onClick={() => setHeight("80px")}
            className='bg-[#0A7BCE] w-full h-[45px] justify-center flex items-center gap-2 px-2 py-1 text-[#F9FAFB] rounded-lg'>
            Sign Up <FaArrowRight size={18} />
          </Link>
        </div>
      )}
    </>
  );

  return (
    <nav
      className='fixed top-0 w-full border lg:border-none newNav px-8 lg:px-[8rem] new_ff z-50 transition-all duration-300 ease-linear overflow-hidden'
      style={{
        height: height,
        alignItems: height === "80px" ? "center" : "start",
        backgroundColor: height === "80px" ? "#F9FAFBCC" : "#ffffff",
      }}>
      {Content}
    </nav>
  );
};

export default Navbar;
